(function () {
  const params = new URLSearchParams(window.location.search);
  const offer = params.get('offer');
  const path = window.location.pathname;

  // BESTBUY用コレクションに来たら、自動で特別表示ON
  if (path.includes('/collections/member-bestbuy-collection')) {
    localStorage.setItem('special_offer_active', '1');
  }

  // 手動ON
  if (offer === '1') {
    localStorage.setItem('special_offer_active', '1');
  }

  // 手動OFF
  if (offer === 'clear') {
    localStorage.removeItem('special_offer_active');
  }

  const isSpecialOffer = localStorage.getItem('special_offer_active') === '1';

  if (!isSpecialOffer) return;

  document.querySelectorAll('.price').forEach(function (priceBlock) {
    const specialPrice = priceBlock.querySelector('[data-special-offer-price]');
    const normalPrice = priceBlock.querySelector('[data-normal-price-container]');

    if (!specialPrice || !normalPrice) return;

    normalPrice.style.display = 'none';
    specialPrice.style.display = 'block';
    priceBlock.classList.add('price--special-offer');
  });

  document.querySelectorAll('[data-special-offer-link]').forEach(function (link) {
    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('offer', '1');
    link.href = url.toString();
  });
})();